import type { TagProps } from "@chakra-ui/react";
import { Flex, Tag as ChakraTag, Text } from "@chakra-ui/react";
import React from "react";

export interface IPropsTagWithTitle extends TagProps {
	title?: string;
	text?: string;
	textColor?: string;
	lineHeight?: string;
}

export const TagWithTitle: React.FC<IPropsTagWithTitle> = ({title, text, textColor, lineHeight = "14px", ...defaultTagProps}) => (
	<Flex flexDirection='column' justifyContent='center' alignItems='center'>
		<Text fontWeight='medium' fontSize='12px'>
			{title}
		</Text>
		<ChakraTag minW='92px' variant='solid' p='8px 12px' {...defaultTagProps}>
			<Text fontWeight='medium' fontSize='12px' color={textColor} textAlign='center' w='100%' lineHeight={lineHeight}>
				{text}
			</Text>
		</ChakraTag>
	</Flex>
);
